import { useQuery } from '@tanstack/react-query'

import { consulta, pedir } from '../api/nucleo'

/**
 * Cuántas respuestas tiene cada formulario de una web y dónde sale, en una sola petición
 * (`GET /api/formularios/resumen?sitio=`). Si el núcleo todavía no lo sirve, o falla, es
 * `null`: el listado sale sin esas columnas y el constructor sin el contador, sin romper.
 */
export type ResumenDeFormulario = {
  id: number
  respuestas?: number
  nuevas?: number
  ultimaRespuesta?: null | string
  paginas?: unknown
}

export const useResumenDeFormularios = (sitio: number) =>
  useQuery({
    queryKey: ['formularios-resumen', sitio],
    queryFn: async (): Promise<Map<number, ResumenDeFormulario> | null> => {
      try {
        const r = await pedir<{ formularios?: ResumenDeFormulario[] }>(
          `/formularios/resumen${consulta({ sitio })}`,
        )
        return Array.isArray(r.formularios)
          ? new Map(r.formularios.map((f) => [Number(f.id), f]))
          : null
      } catch {
        return null
      }
    },
    retry: false,
    staleTime: 30_000,
  })

/** Las páginas donde sale, como las mande el núcleo: una lista (con su título) o una cuenta. */
export const paginasDe = (paginas: unknown): null | { cuantas: number; titulos: string[] } => {
  if (typeof paginas === 'number' && Number.isFinite(paginas))
    return { cuantas: paginas, titulos: [] }
  if (!Array.isArray(paginas)) return null
  const titulos = paginas
    .map((p) =>
      p && typeof p === 'object' && typeof (p as { titulo?: unknown }).titulo === 'string'
        ? (p as { titulo: string }).titulo
        : '',
    )
    .filter(Boolean)
  return { cuantas: paginas.length, titulos }
}
